// @ts-nocheck
type ENV = 'development' | 'production' | 'test' | 'stg'
export const env: ENV = import.meta.env.VITE_APP_ENV ?? 'development'

export const appHost: string = import.meta.env.VITE_APP_HOST ?? 'http://localhost:5010'
export const apiHost: string = import.meta.env.VITE_API_HOST ?? 'http://localhost:5010'
export const gtmId: string = import.meta.env.VITE_GTM_ID ?? ''

// Chatbot 用 LINE 公式アカウントのベーシックID（@付き）。ホームの「LINE連携をする」バナーから
// 連携テンプレをプリフィル投稿する oaMessage ディープリンクに使う。
// 公式アカウントは Chatbot 用と問い合わせ用（社員が人力対応）に分割されており、ここは Chatbot 側を指す。
// STG と本番で公式アカウントが異なるため env でデフォルトを切り替える（VITE_LINE_OA_ID で上書き可）。
// TODO: STG 用の Chatbot 公式アカウントが用意されたら stg 側も差し替える（現状は分割前のアカウント）。
const defaultLineOaId: string = env === 'stg' ? '@407udxxp' : '@298kxwqt'
export const lineOaId: string = import.meta.env.VITE_LINE_OA_ID ?? defaultLineOaId

// 公式アカウントの友だち追加URL。LINE案件操作の準備状態チェックリストのリンクとQRコードに使う。
export const lineOaAddFriendUrl: string =
  import.meta.env.VITE_LINE_OA_ADD_FRIEND_URL ?? `https://line.me/R/ti/p/${lineOaId}`

// LINE ログインのコールバック URL。
// VITE_LINE_LOGIN_REDIRECT_URI が未設定の場合は appHost を基準に自動解決する。
// appHost 自体も window.location.origin のフォールバックあり。
export const lineLoginRedirectUri: string =
  import.meta.env.VITE_LINE_LOGIN_REDIRECT_URI ?? `${appHost}/line-login/callback`

export const sentryDns: string = import.meta.env.VITE_SENTRY_DSN ?? ''

export const firebaseApiKey: string = import.meta.env.VITE_FIREBASE_API_KEY ?? 'test'
export const firebaseAuthDomain: string = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'localhost'
export const firebaseProjectId: string =
  import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'iesapuri-local'
export const firebaseEmulating: string = import.meta.env.VITE_FIREBASE_EMULATING ?? false
export const firebaseEmulatorHost: string =
  import.meta.env.VITE_FIREBASE_EMULATOR_HOST ?? 'http://127.0.0.1:9099'
